import Flex from 'components/common/Flex';
import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';

const PNDonationSummary = () => {
  const orderSummary = [
    {
      id: 1,
      title: 'Water Relife Project',
      subTitle: 'Somalia - Fixed',
      amount: '$150.00'
    },
    {
      id: 2,
      title: 'Food Relief Project',
      subTitle: 'Somalia - Monthly',
      amount: '$20.00'
    },
    { id: 3, title: 'Subtotal', subTitle: '', amount: '$33.00' },
    { id: 4, title: 'Transaction Fees', subTitle: '', amount: '$150.00' },
    { id: 5, title: 'Total', subTitle: '', amount: '$150.00' }
  ];

  const [stickyStatus, setStickyStatus] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY < 10) {
        setStickyStatus(false);
      } else {
        setStickyStatus(true);
      }
    });
  }, [window.scrollY]);

  return (
    <Card className="sticky-top" style={{ top: stickyStatus ? '5rem' : '0' }}>
      <Card.Header className="bg-100 fs-1 fw-semi-bold">
        Donation Summary
      </Card.Header>
      <Card.Body>
        {orderSummary?.map((data, index) => (
          <div key={data.id}>
            <Flex justifyContent={'between'}>
              <div>
                <p className="fw-semi-bold mb-1">{data.title}</p>
                {data?.subTitle && (
                  <p className="mb-0 text-600 fs--2">{data?.subTitle}</p>
                )}
              </div>
              <p className="mb-0">{data?.amount}</p>
            </Flex>
            {index !== orderSummary?.length - 1 && <hr className="my-2" />}
          </div>
        ))}
      </Card.Body>
      <Card.Footer className="bg-100 fs-1 fw-semi-bold">
        <Flex justifyContent={'between'}>
          <p className="fs-0 mb-0 fw-semi-bold text-700">Payable Total</p>
          <p className="fs-0 mb-0 fw-semi-bold text-700">$3320</p>
        </Flex>
      </Card.Footer>
    </Card>
  );
};

export default PNDonationSummary;
